import { BOARD_SIZE } from './types.js';
import { cellAt, placeTile } from './board.js';
export function applyPlacements(board, placements) {
    let next = board;
    for (const p of placements)
        next = placeTile(next, p.row, p.col, p.letter, p.is_blank);
    return next;
}
export function detectDirection(placements) {
    if (placements.length === 0)
        return null;
    if (placements.length === 1)
        return 'across'; // ambiguous; caller may need to infer
    const allSameRow = placements.every((p) => p.row === placements[0].row);
    const allSameCol = placements.every((p) => p.col === placements[0].col);
    if (allSameRow && !allSameCol)
        return 'across';
    if (allSameCol && !allSameRow)
        return 'down';
    return null;
}
function extractWord(board, startR, startC, direction, newPlacedKeys) {
    const dr = direction === 'down' ? 1 : 0;
    const dc = direction === 'across' ? 1 : 0;
    // Walk back to start
    let r = startR, c = startC;
    while (r - dr >= 0 && c - dc >= 0 && cellAt(board, r - dr, c - dc).tile) {
        r -= dr;
        c -= dc;
    }
    // Walk forward collecting
    const cells = [];
    let word = '';
    while (r < BOARD_SIZE && c < BOARD_SIZE && cellAt(board, r, c).tile) {
        const cell = cellAt(board, r, c);
        word += cell.tile.letter;
        cells.push({
            row: r,
            col: c,
            letter: cell.tile.letter,
            is_blank: cell.tile.is_blank,
            is_newly_placed: newPlacedKeys.has(`${r},${c}`),
        });
        r += dr;
        c += dc;
    }
    return word.length >= 2 ? { word, cells } : null;
}
export function extractAllWords(boardAfter, placements, direction) {
    const newKeys = new Set(placements.map((p) => `${p.row},${p.col}`));
    const primary = extractWord(boardAfter, placements[0].row, placements[0].col, direction, newKeys);
    const crossDir = direction === 'across' ? 'down' : 'across';
    const crosses = [];
    for (const p of placements) {
        const cross = extractWord(boardAfter, p.row, p.col, crossDir, newKeys);
        if (cross)
            crosses.push(cross);
    }
    return { primary, crosses };
}
//# sourceMappingURL=word-extractor.js.map